
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ChevronRight, CheckCircle, Menu, X, ArrowRight, ArrowLeft } from "lucide-react";
import { LayoutGrid, Eye, EyeOff } from "lucide-react";
import ScrollToTop from "../../src/pages/ScrollToTopButton/ScrollToTop"
// Navbar Component
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-md py-2" : "bg-transparent py-4"
      }`}
    >
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center">
           <LayoutGrid className="h-8 w-8 text-primary" />
          <Link to="/" className="flex items-center">
            {/* <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMwAAADACAMAAAB/Pny7AAAAaVBMVEX////+/v4AAAAUFBQKCgo3Nze6urr7+/uzs7MmJibBwcH4+Pjz8/Ph4eEGBgYXFxfJycmampqGhoaPj4/t7e3Q0NBvb28wMDBHR0c/Pz+srKxmZmbn5+fb29tZWVkcHBx6enpPT0+ioqIYa/H5AAAN6klEQVR4nO1c2YKjKhAFNBK3uBt3Tf7/Iy9V4Jp0OnNnonngzPRmq80Rai8kRENDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0Pj86CvcfTw3sV7I6X4/4uBoxNcvNb/DR4hnFN+9Ih/BW2606/ofCDz3XMjqHByY2/gBmSOHuxvEAO0L4YRGC8RmDbqiKNH+xpifPR6ec0EcDnRd1XFjqBkEnz8lhL+Hhm+nBn1zcHsnliN92dmfRkRCuFQMaKokbwFXEJWZEB4TMbMDRnzSqi7vgwfy5HKGv66Fyb5jLP7QIYF3a1nwZaMe56vGpLQwydz6DqjpI3LfqFyE49slhkrKr+tCrZeZlfqJfNVl6CMM3Kw4aEk68zl2Fm0JWPaZ5cT17LNNRkuyMzTZ5rmLTtaWzfd+omzaLvMWC0WEKFevTpRkHGj1RGTdSmceBAReIxRsBZtSWYhHwHLXRAtN9+QIRsyhhlER/qeQmC6FZfgcWYMVrbCcyF+uV58q2WmjnXizKOYiP9hubEpj2QMNjSUNsNGAZzIA5lLGR63ysSHczLXbhiLPVIu1bCQbVbEcWFulmPxQCZgpXOYDwB/1zqZmwHlKRk2NsUA5WtsDg0kzbe252Qdw0Qa7Acy4olnJGPm1mkOtm40E6cVW5kRZA6bGJyZrR9mVpzU26l5AOsIrx5cnONmBoXmYZkJs5KSzN6uqi0XOyNpvT3peDKXzSSYrKK0es2G2RUh1YPzeTmcDI5oSehyDYUPWTw6yhNbVghvVMze8qrgS8gEUl3NKENKs+HWs6fob3HGaVisj37LzAizX8cr3D1C0qyKkgfESVRlqYiA7sPygqSGefwGMga7N94KKQevxPWewgVnkqfrg03FvoHMRdhJb/sbLv79GAI/GnlxAPzQLyBjsPNqfBRSZ5Dgo89D+ichC8zV+SvJEIJEyMv8+OoXeJ4gc7ydMR/IYCTftOQPInohYpYic6Db/IwMLC6vK1r6btiIU6hm5rCweU1mHAV87w6MnSz37YEJ7TeS+dBYf8WCDATGo9gLRQYBsYhOlOi8ugWV80e/SmaAhueELoWii8UuhmkMPh59JTp0LGt8FRmQYdcqSgssTHgVbpdZt4S+JTYyW/1VZASXm3DLLJf4BQsCUwRpUjdn4Ws0X0dGjNrvUFCsFuKUy9UhUq+5+fVlCc0+8y8jg4XM6gRsig7c/P6uEuFCSb8on10uF1bxL1MACPdcwpwwcKMTbzxFkAle4fvIUMUG5iYwFq6nWGavZgZw/7Zlpkpn7vkKURa7TW600LxV9Bot/cqZEXpYBP89u/pLr8T9Bfw7tBnZkIEvgg2DJOuYM35tZpDzd8oMka58tfBhfmuUoaqO+VVkxnUmPtKRC31eCJsO0rlSLT5/XwgwyQ5Fg/mczHgOGSNRFZyZ3+I1L8mMTVg/zMx4JlaW6dQ94Fxt8/pVZIgcmBzn60hzLUuUpOF56JwvI6PGmPqvG30g6hFqO/VbgJ+C9kvb9LgC7U9hs/gpHer2lxwA90MrGupbWRa3Oq6crCFH9tM9IaOaLLyIsZvjLaNpNWdSRAj3wqhe52+vQ5V536HNqBqq1FBVcDFYl0mFNqkvPqmG5hyfnrhpt8RJJ9NzHBlJI8wwThaaSRgNM/fH7NnCgoKweFa+oHIxF98Xceb+kDzcjwxOQdbdQpiIDEIBdgtXTVgjH0L8pFRjt/OosgBVMvrWRld5h7RqLYMzobqywmSlw0lzwyR4qKxmswB4B2EdKBkJ28ZTaVzPb618lB3/CLlZywyEzQErwiYXX82gUh1X6VBMSFJZhhI4Jf4y3Q5Tm2aDDb+C3oYjyQAbL4LaH+tqKIKxaBE2X/AfY2KQVMTW8H3c8jF3MybO4NywloogU7c/hAwOJY2EDjNMqJuzQYUAXIbNRg+5joxwCyXftka5mJrloB1SHEijC7JpyZ+kqv8RFstMjDvqVdh8S6czpoRGXxESouifmsVIvaTLEwt5oxMkglWYxOZp7eODmGeGy8XCq6uJbSPNGJxx6sY19vrVEaEZdjzX3hy6cRopqueUS9dUnpR7hO/aFLQiw8HZonfbDKDIP5uWxfnNgMNs6NJjOJdiFcLx4N7Im4bI5k74rlKzUABc5ZS9u7CX1twDx6UsSM12VlpgCmRgYaXOPYq7EvjUISR3xUo7gY5o9m3XWmc0pSPmRaeIkJmNjPDRR/ZBKZ/CUc3JW2ASwEvbBKajFAYTjiRALd+3K/AxbAad5qSqkLHqwabUvYOBjx6KuQp+LJTDVbLxwH4azq5TsyUzGg6uoseZDSyeFtRU7f98L6cDNqhLQtDgubsLi3kADzMzlmT4Oi8jJAcmxj7/sHKw1p7VaC8h2x4Lobnu2hf4Axki861kVlrwJe3kxDxP2MhlmXWgxUDCQjGNZrKnPntKRkY1IiBeRflyePbdfTY8TOSA4nPDrstQeXjg12Br8FFkpkyLGFmct/NIgBassi576nFNbQMilPZdqRUrJtfZbmzWqnmaF/gXodWQR1A5e8JgXvLm5ejG8iZ8+MKB7u9kP/VMN74ZGaeFnHtxuAulC4YUfWFH7OjpKpvvR2GlRRmKChil/JBlxtGou20j/3qLwcANR6UWUNZDZ8DLJ42eptAB0AZNCbg+tx01wDqeEUujLlq0Kbbw+hlWNcckJwnBwL/O8SFR4VeXoAPIXbg0xY6bA9Zk0N0tIUi0WR9cbAucTyEvqesJq++omOtlqgKWY85MbIaAC8p2vzhgrQBE2BxAW7M7QNgMwitb6PLTVfjzllRmr0cGnkwi3DcwoS2QyQ4hI4adJgZ0BXa5EH7TjNF2qmpzp8i886Dbu4OpwFYss9OOPsBam4mHGoDcQ7clNNErYYECbedSa/L+37kx5TOZI5YZOMyJ2r3EOn+0oDgzhTfKzFsjQz0fCjIgMweQ4egqi9AMuulxx8yYlHXjPI8lmfKtBy2znrM224nNQpuNeSVINzF7sXOEQhJQhPfKzryzzGSgh3bmtZH9p9h4ACObS7Xwl+VXTiHM/MHPfHZfgru96x2DzbWjOc4NS+Yhz9EZBI/GkP50q/VtxWWNcLKD5CBHE39GLWClc4Ay+808Uobmt+HhpS6pTDGTR3nN8oByLPlEZkzSEOrYKij+7aagSaiLItMcHpwpcD5nLeHnFIRgeCPcwsuyk7BX8Y7y/6QMCDEzJgC4UgnTidyFzb9vtGDIICIRq6zftfb8IDNzlgzAF+kx8E8COTXv3Lc9yah5RzzMDKfTdoa45rMyw2hT7ss+/3pXmNlcnrpnEpCs2hrn7BKHPViYieFLNeBDdbnIFtnZNeYg+94L89/tW6FZRprjmGUAHQqXk93CUaXJYWJKE/Lm9HlUg5Em3CTDwof/Ovb5HBkqu63TVA67gcZm9CulFlAOVoOrJ0l/6N2gsqZBW6zoDItK1L5kZOm+zfMWHWXYTXopLSxzLMwelxvNovQHW4i0aYulQKM5rNiEGY1WPPi6xQSecJ2FgZSpWi/10hQ/sCNVIPaf+lxjHhAbAtAkHbTMCLTLQGiWt7D/OjBNmVaCHHMcxwNsl0taESNgPXkIn9UCQBemVoFUQLj2rTmvyTRxj6XZ5Mp6kw2eOmVu0jaHBr1qiGzuUA2Y15ESKh5iFwpyiU9dSKbCz65kAH7cQ2jWm9DY3Ixhsze9l+JiC9mH0hqIRF21ZPR/iFLCYXSbW0+qrCicdWFkTzLET2zcHBxA6Xt0CpZN2kHsE9eSB4w6cppRrVHX9c+JbHfor8iot7IaKiB79dGslhmqZJkEAN+dzGFzvQBsSckGteO2rOP7OcyyzDknQ22rg5Fi21dZbtx/KrR9kMxoGkFuDJOdp74saMdaQHX8VfUoGfapKG5FeQ3UgT53PIpG88LsKItZslcYsJ0ZmJvYgH0XkyfypOkUfAH/vNnarJBbDVwAtRxBzY7bhA07sXmMZ4RuTSBs5uuzHsFTp94yMePWU51QZ7kQzTyLMNtGPv/GvcewGTR01fzU0TxfCOlO13OG28nuhcLo7VOXZC4nqsiOpakLdg2E9/4GiauPq4HH4GzSs6//9qxvXR92cWW+fO6eNy5XCvEC0OnCs12GZBffZhs2w2f5bH+58PEUeBmXRWQUIH47KBVRhs7Jtjj5tL15JjOcvpeDXARAOH7ilAG7ntWvoH4wqgjbCW8MMm6fZfMkoaGG+V7ecjyfy13nDHadj62z6HtL9GfhfEbeh1fao8xIeXm9C2A6b3ERnbecqB0o4nMzvsLSvIc1qujPkUHD6JTm1ML4F3cSyyoCMlM+BucHSnEoN0bk5Cz3P/oyN8hvFReDFf/AWYfXA8FGVT7eGmbXkT3D0NPpxO/Vqv4/RBCTY7XMcv4SFrQPG3k6BwVois725BtUJWY4P0UG72tBIyMzbdu+Xu3/D3gVH26foYvbc+5W15HNtWfsg4l0NPheAu/6Mv8aIqwzE29ZCsFMjQrmFLr0o16NWGhxwN54CehrQJemkayr/rKJVXiuUm5AE9w+/GY6TtJz/tQD/kPk1iYbi9aGyy5VE5Uau/mfJQN2JW2d818ibFM+MljdXkTjtVTQF5lL+zAXMHL8bzHfb80FsugdUrmwPvvwxKCL+7ft1Pynt2rLBslMxtGB9fGELWZmCfkrpUl/avxXmabm3tll3H48YStTquOY/uc9FgHOhhNVuXTPS8ekvIaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhsa/wX+g68wHUE+kqgAAAABJRU5ErkJggg=="
              alt="AssessPro Logo"
              className="h-8 w-auto mr-2"
            /> */}
            <span className="font-bold text-xl">AssessPro</span>
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8">
          <Link to="/" className="hover:text-primary transition-colors">
            Home
          </Link>
          <Link to="/features" className="hover:text-primary transition-colors">
            Features
          </Link>
          <Link to="/pricing" className="hover:text-primary transition-colors">
            Pricing
          </Link>
          <Link to="/question-banks" className="hover:text-primary transition-colors">
            Question Banks
          </Link>
          <Link to="/about" className="hover:text-primary transition-colors">
            About Us
          </Link>
        </nav>

        {/* Desktop CTA Buttons */}
        <div className="hidden md:flex items-center space-x-4">
          <Button variant="outline" onClick={() => navigate("/login")}>
            Log In
          </Button>
          <Button onClick={() => navigate("/register")}>Get Started</Button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? (
            <X className="h-6 w-6" />
          ) : (
            <Menu className="h-6 w-6" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white shadow-lg"
          >
            <div className="container mx-auto py-4 flex flex-col space-y-4">
              <Link
                to="/home"
                className="py-2 hover:text-primary transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/features"
                className="py-2 hover:text-primary transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Features
              </Link>
              <Link
                to="/pricing"
                className="py-2 hover:text-primary transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Pricing
              </Link>
              <Link
                to="/question-banks"
                className="py-2 hover:text-primary transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Question Banks
              </Link>
              <Link
                to="/about"
                className="py-2 hover:text-primary transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                About Us
              </Link>
              <div className="flex flex-col space-y-2 pt-2 border-t">
                <Button
                  variant="outline"
                  onClick={() => {
                    setIsMenuOpen(false);
                    navigate("/login");
                  }}
                >
                  Log In
                </Button>
                <Button
                  onClick={() => {
                    setIsMenuOpen(false);
                    navigate("/register");
                  }}
                >
                  Get Started
                </Button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

// Hero Section Component
const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="pt-32 pb-16 md:pt-44 md:pb-24 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              Streamline Your <span className="text-primary">Assessment</span> Process
            </h1>
            <p className="text-lg md:text-xl text-gray-700 mb-8">
              Comprehensive assessment platform for companies to create, manage, and evaluate candidate assessments effectively.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg" 
                onClick={() => navigate("/register")}
                className="text-lg"
              >
                Start Free Trial <ChevronRight className="ml-2 h-5 w-5" />
              </Button>
              <Button 
                variant="outline" 
                size="lg" 
                onClick={() => navigate("/demo")}
                className="text-lg"
              >
                Request Demo
              </Button>
            </div>
            <p className="mt-4 text-sm text-gray-500">
              No credit card required. Free trial for 15 days.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <img
              src="https://img.freepik.com/free-vector/team-checklist-concept-illustration_114360-29429.jpg?ga=GA1.1.693226630.1720413106&semt=ais_hybrid&w=740"
              alt="Assessment Platform"
              className="w-full h-auto rounded-lg shadow-xl"
            />
            <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-lg shadow-lg">
              <div className="flex items-center space-x-2">
                <div className="h-4 w-4 rounded-full bg-green-500"></div>
                <p className="font-medium">500+ Companies Trust Us</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

// Features Section Component
const FeaturesSection = () => {
  const features = [
    {
      icon: "🧠",
      title: "Comprehensive Question Banks",
      description:
        "Access thousands of quality questions across multiple domains and difficulty levels.",
    },
    {
      icon: "🔒",
      title: "Secure Assessment Environment",
      description:
        "Advanced proctoring and anti-cheating measures ensure integrity of every assessment.",
    },
    {
      icon: "📊",
      title: "Detailed Analytics",
      description:
        "Get comprehensive insights into candidate performance with powerful reporting tools.",
    },
    {
      icon: "🎛️",
      title: "Customizable Workflows",
      description:
        "Tailor the assessment process to match your company's unique requirements.",
    },
    {
      icon: "🔄",
      title: "Seamless Integration",
      description:
        "Integrate with your existing HR systems for a streamlined hiring process.",
    },
    {
      icon: "👥",
      title: "Multi-level Access",
      description:
        "Define roles and permissions for different team members within your organization.",
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Powerful Features for Every Assessment Need
          </h2>
          <p className="text-lg text-gray-700">
            Our platform provides everything you need to create, manage, and evaluate assessments effectively.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow border"
            >
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Carousel Component
const Carousel = ({ slides }) => {
  const [current, setCurrent] = useState(0);
  const length = slides.length;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(current => (current === length - 1 ? 0 : current + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [length]);

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  return (
    <div className="relative h-full w-full">
      <div className="absolute inset-y-0 left-0 z-10 flex items-center justify-center">
        <button 
          onClick={prevSlide}
          className="bg-white/80 p-2 rounded-full shadow-md hover:bg-white transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
        </button>
      </div>
      
      <div className="absolute inset-y-0 right-0 z-10 flex items-center justify-center">
        <button 
          onClick={nextSlide}
          className="bg-white/80 p-2 rounded-full shadow-md hover:bg-white transition-colors"
        >
          <ArrowRight className="h-5 w-5" />
        </button>
      </div>
      
      <div className="overflow-hidden h-full">
        <div 
          className="flex h-full transition-transform duration-500 ease-in-out" 
          style={{ transform: `translateX(-${current * 100}%)` }}
        >
          {slides.map((slide, index) => (
            <div 
              className="min-w-full h-full flex items-center justify-center px-4" 
              key={index}
            >
              {slide}
            </div>
          ))}
        </div>
      </div>
      
      <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`h-2 w-2 rounded-full transition-colors ${
              index === current ? "bg-primary" : "bg-gray-300"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

// Testimonials Section Component
const TestimonialsSection = () => {
  const testimonials = [
    {
      quote: "AssessPro has transformed our hiring process. The quality of candidates has improved dramatically, and the time-to-hire has been reduced by 40%.",
      author: "Sarah Johnson",
      position: "Head of Recruitment, TechCorp",
      image: "data:image/jpeg;base64,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"
    },
    {
      quote: "The detailed analytics and reporting features give us insights we never had before. We can now make data-driven decisions about our hiring process.",
      author: "Michael Chen",
      position: "HR Director, GlobalFinance",
      image: "data:image/jpeg;base64,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"
    },
    {
      quote: "The question banks are comprehensive and well-structured. We've been able to create challenging but fair assessments for technical roles.",
      author: "Amanda Rodriguez",
      position: "CTO, InnovateSoft",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8JD-dHvLagqSDQP5JtzPxBdLqeCKuoX0lU8-u5BkUmFhRRWrMVyOcRHQ&s"
    },
    {
      quote: "Customer support has been exceptional. Any questions we've had have been answered quickly and thoroughly.",
      author: "David Patel",
      position: "Recruitment Manager, HealthCare Plus",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLtTf7y7jNa-QCTpkTt3MlrtmXLpk6pUvWgg&s"
    }
  ];

  const testimonialSlides = testimonials.map((testimonial, index) => (
    <div key={index} className="bg-white p-8 rounded-xl shadow-lg max-w-2xl">
      <div className="flex flex-col items-center text-center">
        <div className="mb-6">
          <img
            src={testimonial.image}
            alt={testimonial.author}
            className="w-20 h-20 rounded-full object-cover border-4 border-primary"
          />
        </div>
        <p className="text-lg italic mb-6">"{testimonial.quote}"</p>
        <div>
          <p className="font-bold">{testimonial.author}</p>
          <p className="text-sm text-gray-600">{testimonial.position}</p>
        </div>
      </div>
    </div>
  ));

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg text-gray-700">
            Join hundreds of companies that trust AssessPro for their assessment needs.
          </p>
        </div>

        <div className="h-[400px]">
          <Carousel slides={testimonialSlides} />
        </div>
      </div>
    </section>
  );
};

// Security Features Component
const SecurityFeatures = () => {
  const securityFeatures = [
    {
      title: "End-to-End Encryption",
      description: "All data is encrypted in transit and at rest using industry-standard encryption."
    },
    {
      title: "Advanced Proctoring",
      description: "AI-powered proctoring detects suspicious activities during assessments."
    },
    {
      title: "Role-Based Access Control",
      description: "Granular permissions ensure users only access what they need."
    },
    {
      title: "Compliance Ready",
      description: "Designed to help you meet GDPR, CCPA, and other regulatory requirements."
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Bank-Level Security for Your Data
            </h2>
            <p className="text-lg text-gray-700 mb-8">
              We take security seriously. Our platform is designed from the ground up with multiple layers of protection to keep your data safe and secure.
            </p>
            <ul className="space-y-4">
              {securityFeatures.map((feature, index) => (
                <li key={index} className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                  <div>
                    <h3 className="font-semibold">{feature.title}</h3>
                    <p className="text-gray-600">{feature.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <img
              src="https://img.freepik.com/free-vector/global-data-security-personal-data-security-cyber-data-security-online-concept-illustration-internet-security-information-privacy-protection_1150-37372.jpg"
              alt="Security Features"
              className="w-full h-auto rounded-lg"
            />
            <div className="absolute -top-6 -right-6 bg-primary text-white p-4 rounded-lg shadow-lg">
              <p className="font-medium">ISO 27001 Certified</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

// Integration Partners Component
const IntegrationPartners = () => {
  const partners = [
    { name: "Slack", logo: "https://www.logo.wine/a/logo/Slack_Technologies/Slack_Technologies-Mark-Logo.wine.svg" },
    { name: "Microsoft", logo: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMwAAADACAMAAAB/Pny7AAAAh1BMVEWBvAb/uggFpvDzUyXz8/P/tADzRAAAnvDz/v/79///+fN9ugDy9//29Pjz9fjK3q7zn4zz5eHp7t7e7PMAofD07t6u1vLzvLHzPQB1tgC21IeHyfH604j43a4Am/Dz0sza5sjzMQDzl4Ku0Hjzw7rQ4bbt8Od7xfH34bb70HwAl/DI4vP25smrnwjZAAABYElEQVR4nO3cSVICQRRFUVRagRJsUBrBshRE3f/6HEDCIKf+oKLi3AXkz7OB12o3qNalP/CfnTHPQW2Kw/vjt7ugMkwxLV9CKt/7hwuDah7U/TjDdG9C6k4SZjFshQQDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwNTc0zZDak8Yar5MKQc055Ogvo4jugMPqtFSNU2wxT9oIp0YRBVsjR1q6kBwdQ1mLp2xtxGlQ6MoioyzMNuGdJudtSMvvarkPbbIsOseyGtdwmz7wT1lGMer0PqLRNm1bkKCQYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBqbmmKCplu9LTLUUs6B+0oHf16BOm0MN3WpqQH/QjesYoFCnfwAAAABJRU5ErkJggg==" },
    { name: "Google", logo: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMwAAADACAMAAAB/Pny7AAABR1BMVEX////qQzU0qFNChfT7vAXs8v5MivQ+g/TA0/tPjPXi6v37uAByn/Y4gPTqQTMvp1DpNSQmpUrpOir7tAD1+vb+9fXxjojpMR7pLBfqPjYwffT87Ov62dfzn5roIQDxiYP+7s395rWPsvidu/n19/58woyk064LoD1yvoT74d/4xsPzpqL5zsvylpD+8tn8wgD8z2rk8ee43L/2t7PvfnbsYljrUEXub2bsWlD7wDX4qxP81IX8xU793Zr/+On94qrV4fz81HhglfWzyvqPyZxVsmvO5tNluHgzqzr849X6wGPwchjziCP1mhvtWi/vayvnIzruaEr7y4no1o3OtiFttWWtszPduB2Krz9kq0kApVnruha+tSsPcfKZsDvoyGPm7NS+2OEzmpNBiuI2o3BAjtU8lL06mp84oIM2lLA+kMoxpGCpzsocl60rAAAKuUlEQVR4nO2b6X/aRhrHhaDGDmGEFECKMSJOjLhjgzicwy51ONxNsml3szk27R6t3Vz7/7/eGXEbjTQjZiTRT34v208kff2c8zyDIHwTuTJLCvpbvCqTq1QO6lWzls8W2u12r90uZBs1s1o/qFRyW4SVq9TrZqPdiaR0XdNUNTWVqmqarqug28vWIFQu6O90Ve6gWsv2IrqmphQAIjYCACiqpiun7bxZr4TXRJVqrdABqqrYUtxgUlKa2m1nzYMw8lTMQq+L7OEOskSkgk47Xw/621eVMVGIUIEsLAROe/mDoAnmqhS6EcULyZQHKKDbqQZNYanawcU6FY8SqQVNkqmldO82WeXR9EKQ6TpXU3QmJFMeTc8GlawrJlMUS5rWqASAkjO7zFEiyDqg5jdOptrWFPYoE5yO6Wvs1AsgxQcFSVHa/tXRXP40xcHDFgKpbt4n49Q7gJOHLaSAji/GyUbYFBZnwa6gwR0l1+XrYUs4aodzzTF17h62kKLxbNgyBc0ns8xo8txYDnqqryzI1Xi1a9VT1V8URKP1uBx1zC7HOomX2uMQODX+xQVD0zVZsxT8ysjrUlKMPc3nNLYivcE0CWTawdkFsjCtnX8uFv9T8kxAY8xSCJAllWXL0giQRWHLItSCy2Os7SKYfhxeMNIYs1QDZNEZsxxEAuphOLBkguktJyxsc7IgbF5g0JpM1SyhJRS5zzJnyW9kF4ih6zo4bTfytVotn2+0e0DTdY2om2DtY0LV86ICAJDStE6+utYh5uq1dkp324EA1nlMyJ16C360O4qcNhza9pzZQ6MkLA/z+iIIWU8sQFG6nbzr6Dtj9roAk/ZBqsCaxYx42lAqnSzhKPIg3wN28QNU5iyVnofoV9QezT4iZ7aV9bdozFkyefqsrGg9k3K1AqPn5mZEZ84i1KmdDGhdL1uiinm60skyz8nwL0btZIqa9Th2OMiqC+PoWfZDP1OjZFG7Vc9/0YwZmf3peLBkKHtloPU2+ohKZxKhXHbnDTrDAH3j+whtGDiAfR6DyulUKIrCYMlV0xT2tRKpTRP9QDll4hum0ubB8iONYUCK1TfwuRr4l+d375LbhYtvMNO9WOxFhJAGKBxyKUudxGLHL/9KRAPtEm6We49iUI9fEdAAPjHLUE8QS+w48cI9cJROuO0iPHwam+qlW+CASMhZhLMZS+z4sUvg6OG5JWqv85PEgubYMXB05qtG1jqMLev4Od7V1HbQ3+qqs8QqDTZHK92QJ7Ll8J8HzivbrAZYNJecdRi7qeM7tq6m5UNvmPMniXWahI2rKZ0g7rjS6eGjNRarHbhJA5TQZzLYyqwbxlLi1U83MlnYy6UgpM8wMLCPXqYBkS0wzPlTLMzxy6WkltoCwwjnWBaU1eaBsxWGEb6/g4eJHcdmOVrphT4tQ504WAbRvLCMA0DgP3QhkRPKJHAQDaNpDGedO3nZhObx87sRJRv0h5Lo0BUGuRoAYT/GWPrBMWRmNC9/Dvo7ieSOYulvHh599B0nYd/o7mVIdx56gLl1O7rDQxd9zAvd499SwgMLhNmP81B0F/NCgvhHLD94g0lGeWj/GeaFZ0Qwdw5DBfPgyP6FzvV/DnMeKpj7GBj7g9mavLBwg0nexuQzIpTESahg4he37F9I5mXfhwtmp2/7PqfDzBLMvVDBRJP2MA85xj8/mH17GNwwI+Qw9lXzkAjm0Z8IJvE0HTIY+xYAP2ZahjkJG4x9C0AG46kzCyvMk28wHGHsm7NvMNsNE7oEsAlM6OqMPcyWFs0NYMLXztin5i1tNO1htvQIYA9DeDjzNJzxvdEkPDafbQcMCUvYBhq488xWjpqwMNs4BMTNALZyPBuNY2C2cXAe38MMAfmuNHiNZzEwfJdNvAbnuN0ZEUss8XdPMPTLJiIY3EqDaEEbi73+hyeYnT1KkVkGt2wiygAf3khSkx7mqL9Lq9skpsGVGaIM8PadKEoDehgP+GRR1sc+wJXll/cihBl6O6DRqX9BYJnkBR7GrQd4IyJJYssHmGdREhhsZna5ohWLvRMnkss+wNwn8TLsSlNwOdJ8eD9l8cU0ZIUJn8wcrzXGXv9TnEsuco+aXZJchr/TIDheOH2zxOKDaY7u7xPAOMU/fqjx4d0yC4oaD7WGRv0LEi9LOoQM9pL26/erLKIkcTbNMxLDRJMPnJ5hd31+lpFXTTPkaprviMI/HnWIf8Huhw3QxdZZRLFk8MwBu2SGwd1omGrtJyext+/tWERJHvFjOSKKGFgyXZ5zM5/9Ys+CHI0fDJlhonHHkBHW/OxfGBREU+TFckR2lsFdNVnofKU/w5llEja8MhpRjUGXgFyftPhpY+y1Ewqi4ZPR+r8SsUTj910ftUgBNhl5VZLII6Mdkdkl6nSWmeuJe7jMw2bMnobwUEbkZbMfar+90cBgaNh3nA+SRNHv3DEvdGJlZBIWWG0GjGmIzmQTGKe+bC7YbbqGy5xGYkuzu0fK4loxp/q3bQPjBw1Zs2zp1z7ZI/9TIoeBnsauePb3iFnie6QPHctUNKymNf0dUh+DhnE4Y66qeUkBA3OayKR6PiPNY8gwcaLwt1SkcTRoHBadDWETMxFZXp4oLUtUNGJp04Jza4+GJbmD/+HMugw600Ca4WgDnPR/d2hYoGHIvQw+nSoHIMnywGvkpEfFy99+p6BxO2Le1EikdDQYOMOWJ5ymAVPI5dX1Pmn8x5MUEYOUHtCaBhqnVG5R+1rTGJfQ3+3y6x9RwirjNGHGvITa0RCOXDaorNMcjOXpeyTxI6mrURoGqiXROhr6IlkaD0hHHTBWhrK89G8/XRPNMW/TRP9URQ+mQdaRhmOS4GkOhuLq30uSv/7hHjjxHeLiv/y2oTcaZB7RORkgm4jiuull6bNrG5B0Py3byZOjzXjkklxu2dSe9MgoiiVZxjz78pPLaCa+58HJkDxktBWgUqkki8WBYbSQjMFgLJbQf3P6G12Ke07GiSe9OJml8kY0lmSENJVM0iXJl18cTpv73pzMkrg5Db0uP2LPNckd7yywEQiARip9urZ3tTjuEhOZWrT9MxPJV19s8wBN528nIxiar59tAmeTgJnS0J4G2NCIv+3cDJx93M9lyZUeBEIjyVc3WjXndSwpDeUhmh3Ol2WapKc2Zp2GQbnxRHP5cX/uatSHGKwCohFLV7OKE4+zYgmORv56beXouOvKj0JBxQ3Map/RaHCfIYuATjdB1Bt0Kvj4e5Ixi5A2pIDSQOnqmjELlBFI14na6P8xZ4F9mtej52YsnK5Qjcb+pwF5yOsqSNr3NFAac7xxZJT8pJE2Hsg7qyn6ZxxJMniiIBV9ymoSv3BZ0mjsR8mRRV9utsMjzpC3r8ny2I+r4JZGRa7GgR5GN4DfTOlWmV9ek2Xi4TsjNVtDPjhyqbzJStEzjsQeR9psO7oJjsEYRyqJ9Ms3ZkobMjscOVAUS7CZxi0oKCRJMBv7HPa2ahaH4kY8EEQcel69s1a6hXi8VVJEMi76ViKJ1GwNxpCHDgiCyMPyIOhIsVOzZRSHEtlOCQVJCZpkYASUiQnUHLVa1rbPISlI1oJQGhaN1igscYJVujkatQZlGESz7d9U022gOCwbLcgRepC50k0oaCbDGBSLZaSitaodjdD/CK1nuSm9UNCfslX6P3Wasp6zPDT0AAAAAElFTkSuQmCC" },
    { name: "Salesforce", logo: "data:image/png;base64,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" },
    { name: "Zoom", logo: "data:image/jpeg;base64,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" },
    { name: "HubSpot", logo: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMwAAADACAMAAAB/Pny7AAAAnFBMVEX///9FU174dh8/Tlo8TFj8/P21ur0qPUtrdHz5+frU19lDUV3a3N5ga3RRXmmorbJbZnDr7O3h4+QwQk/4cxWfpap+ho2YnqQ2RlP4bgDy8/SwtLi8wMPJzM9LWGN3gIf80bz+9/L5hD393s74gjGGjpT95Nf5lFz7tZH8ya/4ZwD7vZ0ZMUH6q4L4eyr5nGj+7+b6o3f5ikf3WwAQoFtQAAAI10lEQVR4nO2aiXbiOhKGYyywsWzjFbxhOxCzhSUw7/9uo9ULAYcw3Tc3Z+o7p08nlhf9qlKpSsrLCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf4eP82Kx3v50L/4M20FAiNevP92RP0A5CAaU+Hznhtffo/L1sGNaBsFbeau5XAfBafVP9+pJVhduGKLm/XPr62YXE6PFv2RGrRZSTLz53FoGrDVY/A7b9Frm9RCLthtC/4XUc2YwWJfXjR9rIeZudPiXsVzE0jSLa9s8LWY4JiTdawm9Nn7gufHw6w/ce0/5tovjeLcLSIw+dcMwmf9C6I3g0EdhO46Tp+1PDnV6Tcl6e5rRe+yw9x43nVqWY03T5Fbrx/vl7bwsYxq33rozvTzyAHD55lqjRxhjbdIRYyN6bdTb0ZTeE8167OcWKEIqxipCqLoph7FaEDMEV1F4S8NZcPx4SEKDjhRF8a/EqOTal2LIPT1ihiPNx4oA+/v07p0kdpGe784dKyxJ6D7euHns3R+Wvycm1WopjH2PEbd00YnXbVdbktD9dn3fMDGs3PvnxRh7aRSpaZ/df9nyRNwqXpSNcahlrsQM3UzXIucHxOSIKYlUO0eI6ol0t+dtr5tjTLLoTT1JbojxdA0p6g+ImWtMi1qlWTYpEFIiy+x7G3G1dUwKgvPyvhjDIt36CTFTZpgoZLPVSx3NnvdrIVHtQF3tIqLa6vOc+V/FDLOUMGkCiDuhv2dJR4xrzA2zG2Qc6llIFx8ezvXrRcudT8IwTI3WY6/bt3gQDzZ04qzeyUpzXHZCMxdj9Xlrr5ixruZ57jeDYWIlz9HUrcUMX7KpRZZPR69aYz/O2TSZya4O3a4F3ZluK6qKFUcPW51bkjQmiE/L7elypIvm4nIur8RgO5wQ5re9pl+MxZbPlhiyCCpRLQaFRkE6xVH0elokXEx4xwnTHFMldFIh1Q4b67AlJzjSgpplAOS/pkJjYhTM/fcZMby1YxmlJQZbDmpWRqSN5BuYGFTcdomZ316C1Kh9W0lMIosDnoYOyo4Y9iXtcTEvD4shVlHkaPGVUdznsFa/uqWm0uQKJNYg325N6lNHCmW3vRaj+P1ieKIseFwMD8DEZbgq8hUx+BH/FYdmcuVrE25LjHPbtjF7LHJq0SdZlgX8H+U/ZVsM9ehey6AibDFhTvKoGJTrs0lYWWwSqDkPA54YfdX39YnRto8pumRXmekZM4u9RpMWfQ+Eb13Oh8PpIuTEH42YXCdYkx4xCvLbsKF7UAzSR2zozYrPkyk3ROVLwyEfTbNGDreZqot4ZBZcjcF+E8U0KdfYtF9t+E5BfKrFqI6ZJIl7J7Lotbtc8ZgYVMgQNg7p3FFznoIlemuWR1EhY6nJ3qjq9StdpiYq2C+bmJcxpWwthbplI+bLdeZpMcgy6rakoG4gkwKvQlHzssgWgW7E5ovSWpMMNkN92kdeLgfHsmndsjItOL88ngE8LSZKW85rcrcTdydZEfl1/EGY9X/MvEydtjrAL/lUbNn0XPJ6jmXJ+bAY5GstHp4zajd91NkSXY+6O68UTY5V5LDMZ0p7HnUStTmdbKgiP73zULZst27pssM20B4Vg4pJi9HD0SzqlsMh7Slq1S2Jl+l74W0ave7RF2LUeYp1EllSTPDWLTkvrIBefiPRTJ/LAK6y5hENYdGofellaFo8TCOdPs9Csdp5igt0ajGLzvOrNXU9Oo2ey5ofygBGD4ohTHiY1qSYK8uYetcyV2K4ZZ4W00k074mZM+fv5ivUzTD6VB7z6KvsE2mZqzljY2G3W25Wvn3bze7VM6xVa2b5XJUzxWX+4hidd7GvfSrDhikzDU2+uRg22+vWCYtmNA8qWeI/6Ow6bViAW3wjmt0VU0Xsp7op5GLo3Xx5aOcVBk+VxdeMegg+icHtLRavGTA+P4L2YRqb/+TSyx8om1ONrYzSmVyWHiGWTbKEpW0HvmiiGZeX4TqzT1g8VrTazchCU7unWHly+rPc/T/UalZ81znYNmL69hL6xXhsTOXUcCvcCPDYZlKkS0dzZzSjl+rmOFKn/LvjkBdi6KUWg9VKLq0hS6K1lP1WslwsGBxERbYUWqiX8RQVK+nTYpKCDWpUjDzXHBWY55I8GOmsCVkpU2pUNDXDqGKGmeeI9NgKM8PMKoXlAX7ViCFtekqKAzcrmFBki/h2FhXm+n25+lhuxCHOrmSjx9M6q2dr5IvdmTmvPqLc0q1cZPkiXHkRayIlQDWbFQ7vFc8D53zbDGHbsWxRi+69lhjyGsUiuTxvxJo0rzyDCkj9f1mImnPH85sx3/LBdkG+N3lGzHjmi6FEKu9UE4pGfDXEiDTxml5FvFcuFn0W1xVZsjRiFLahzuu0JsK8H+tyOZC12U6eBUx4SYvJ57SnxJBsSlPa+FZ93zjcyzRf6NzXE0iLOk8pez1pifHbTWpzBkETsVgeQsmquQ5uiVOPxP52TPtyEzCpIrX14XbCS9KAZj+DVJVOs7KPrSZjJkbwK/4BISaL5HNYjfJ6ErzHRMvpEMdBY5+4dd7k5eIxVbldnekRram7YnJEr9U7miMH0wvELbB9tbybhYJYm4qw0zV96hCvE5tQltwDFLnZi1fk1MuQqjizOkpvqRayoqxObLOJutni0DmFcnXMPqfNbpfN0xsnZ9bVyVmSFnSjzypGnw5HxvNKp016lV0P1ng01a2rJiGGvMaYTXW9mGX8ja+r1Yqel/MC+eVjezit16fD9tNpU1ZY5J35nYhmGhS3o9Tg1zpjYhr3jnnGnmF4t80+9kyzU683Yjp8bAY76lzx+etzv4R+7oGz1L/PHTFi5Q8e0PIv4raY5VFswnz3DPNnuS3mXf6B068yzP+DGPFXQfE3/4Thp7kTADY7eni+/l1ThoiJyFIZfQry22AXHH6Xk5GEJJxRbiwTv00JAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPxl/gvrJLv3vffkcwAAAABJRU5ErkJggg==" },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl font-bold mb-4">
            Seamless Integrations
          </h2>
          <p className="text-lg text-gray-700">
            Connect AssessPro with your favorite tools and platforms
          </p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
          {partners.map((partner, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="grayscale hover:grayscale-0 transition-all duration-300"
            >
              <img
                src={partner.logo}
                alt={`${partner.name} logo`}
                className="h-12 md:h-16 w-auto"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// How It Works Section
const HowItWorksSection = () => {
  const steps = [
    {
      number: "01",
      title: "Create Your Account",
      description: "Register your company and set up your admin account in minutes."
    },
    {
      number: "02",
      title: "Build Assessments",
      description: "Create custom assessments or use our pre-built question banks."
    },
    {
      number: "03",
      title: "Invite Candidates",
      description: "Send assessment invitations to candidates with automated scheduling."
    },
    {
      number: "04",
      title: "Analyze Results",
      description: "Review detailed reports and make data-driven hiring decisions."
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            How It Works
          </h2>
          <p className="text-lg text-gray-700">
            Getting started with AssessPro is quick and easy
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              className="relative"
            >
              <div className="bg-primary/10 p-8 rounded-xl h-full">
                <div className="text-5xl font-bold text-primary/20 mb-4">
                  {step.number}
                </div>
                <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <ChevronRight className="h-8 w-8 text-primary" />
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Pricing Section Preview
const PricingPreview = () => {
  const navigate = useNavigate();
  const plans = [
    {
      name: "Basic",
      price: 29,
      period: "/month",
      description: "Perfect for small businesses",
      features: [
        "Up to 50 candidates",
        "Basic question templates",
        "Email support",
        "Basic reporting"
      ]
    },
    {
      name: "Pro",
      price: 79,
      period: "/month",
      description: "For growing teams",
      featured: true,
      features: [
        "Up to 150 candidates",
        "Advanced question banks",
        "Priority support",
        "Advanced analytics",
        "Custom branding"
      ]
    },
    {
      name: "Enterprise",
      price: 199,
      period: "/month",
      description: "For large organizations",
      features: [
        "Up to 500 candidates",
        "All question banks included",
        "24/7 priority support",
        "API access",
        "Dedicated account manager"
      ]
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-primary/5">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Simple, Transparent Pricing
          </h2>
          <p className="text-lg text-gray-700">
            Choose the plan that fits your needs. All plans come with a 15-day free trial.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {plans.map((plan, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`bg-white rounded-xl overflow-hidden shadow-md border ${
                plan.featured ? "border-primary shadow-lg relative" : ""
              }`}
            >
              {plan.featured && (
                <div className="bg-primary text-white text-center py-1 px-4 text-sm font-medium">
                  MOST POPULAR
                </div>
              )}
              <div className="p-6">
                <h3 className="text-2xl font-bold mb-2">{plan.name}</h3>
                <p className="text-gray-600 mb-4">{plan.description}</p>
                <div className="mb-6">
                  <span className="text-4xl font-bold">${plan.price}</span>
                  <span className="text-gray-600">{plan.period}</span>
                </div>
                <ul className="mb-6 space-y-2">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="flex items-center">
                      <CheckCircle className="h-5 w-5 text-green-500 mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <Button 
                  className={`w-full ${plan.featured ? "" : "bg-gray-800 hover:bg-gray-700"}`}
                  onClick={() => navigate("/pricing")}
                >
                  Choose Plan
                </Button>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="mb-4">Need a custom solution?</p>
          <Button 
            variant="outline" 
            onClick={() => navigate("/contact-sales")}
          >
            Contact Sales
          </Button>
        </div>
      </div>
    </section>
  );
};

// CTA Section
const CTASection = () => {
  const navigate = useNavigate();
  
  return (
    <section className="py-16 md:py-24 bg-primary">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to Transform Your Assessment Process?
          </h2>
          <p className="text-lg mb-8 text-white/80">
            Join hundreds of companies that have streamlined their candidate evaluation process with AssessPro.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button 
              size="lg" 
              variant="secondary"
              onClick={() => navigate("/register")}
              className="text-lg"
            >
              Start Your Free Trial
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              onClick={() => navigate("/demo")}
              className="text-lg bg-transparent text-white hover:bg-white/10 border-white"
            >
              Schedule Demo
            </Button>
          </div>
          <p className="mt-4 text-sm text-white/70">
            No credit card required. 15-day free trial.
          </p>
        </div>
      </div>
    </section>
  );
};

// FAQ Section
const FAQSection = () => {
  const faqs = [
    {
      question: "How does the free trial work?",
      answer: "Our free trial gives you full access to all features for 15 days. No credit card required, and you can cancel anytime. At the end of your trial, you can choose a plan that fits your needs."
    },
    {
      question: "Can I change plans later?",
      answer: "Yes, you can upgrade or downgrade your plan at any time. When upgrading, the new features will be available immediately. When downgrading, the changes will take effect at the end of your current billing cycle."
    },
    {
      question: "Do you offer discounts for educational institutions?",
      answer: "Yes, we offer special pricing for educational institutions. Please contact our sales team for more information."
    },
    {
      question: "Is my data secure?",
      answer: "Absolutely. We use bank-level encryption and follow industry best practices to ensure your data is secure. We are ISO 27001 certified and GDPR compliant."
    },
    {
      question: "Can I import my existing questions?",
      answer: "Yes, our platform supports importing questions from Excel, CSV, and several other assessment platforms. Our team can also assist with bulk imports."
    },
    {
      question: "Do you offer white-labeling?",
      answer: "Yes, our Pro and Enterprise plans include custom branding options. You can add your logo, use your color scheme, and even use a custom domain."
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-700">
            Have questions? We've got answers.
          </p>
        </div>
<div className="max-w-7xl mx-auto px-4 py-8">
  <div className="flex flex-col md:flex-row items-center md:items-start gap-8">
    
    {/* Left side: FAQs */}
    <div className="w-full md:w-1/2">
      {faqs.map((faq, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          className="mb-6"
        >
          <h3 className="text-xl font-semibold mb-2">{faq.question}</h3>
          <p className="text-gray-600">{faq.answer}</p>
        </motion.div>
      ))}
    </div>

    {/* Right side: Image */}
    <div className="w-full md:w-1/2 flex justify-center">
      <img 
        src="https://img.freepik.com/premium-vector/faqs-concept-illustration_86047-992.jpg?semt=ais_items_boosted&w=740" 
        alt="FAQ Illustration" 
        className="max-w-full h-auto rounded-lg shadow-lg"
      />
    </div>

  </div>
</div>


        <div className="text-center mt-12">
          <p className="mb-4">Still have questions?</p>
          <Button 
            variant="outline"
            onClick={() => navigate("/contact")}
          >
            Contact Support
          </Button>
        </div>
      </div>
    </section>
  );
};

// Footer Component
const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center mb-4">
              {/* <img
                src="/logo-white.svg"
                alt="AssessPro Logo"
                className="h-8 w-auto mr-2"
              /> */}
               <LayoutGrid className="h-8 w-8 text-primary" />
              <span className="font-bold text-xl">AssessPro</span>
            </Link>
            <p className="text-gray-400 mb-4">
              Comprehensive assessment platform for evaluating candidates effectively. Trusted by 500+ companies worldwide.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"></path>
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"></path>
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"></path>
                </svg>
              </a>
            </div>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Product</h3>
            <ul className="space-y-2">
              <li><Link to="/features" className="text-gray-400 hover:text-white">Features</Link></li>
              <li><Link to="/pricing" className="text-gray-400 hover:text-white">Pricing</Link></li>
              <li><Link to="/question-banks" className="text-gray-400 hover:text-white">Question Banks</Link></li>
              <li><Link to="/demo" className="text-gray-400 hover:text-white">Request Demo</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-white">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white">Contact</Link></li>
              <li><Link to="/careers" className="text-gray-400 hover:text-white">Careers</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-white">Blog</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><Link to="/terms" className="text-gray-400 hover:text-white">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-gray-400 hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/security" className="text-gray-400 hover:text-white">Security</Link></li>
              <li><Link to="/gdpr" className="text-gray-400 hover:text-white">GDPR</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 mt-8 text-center sm:flex sm:justify-between sm:text-left">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} AssessPro. All rights reserved.
          </p>
          <div className="mt-4 sm:mt-0">
            <select className="bg-gray-800 text-gray-400 text-sm rounded px-2 py-1 outline-none">
              <option value="en">English</option>
              <option value="fr">Français</option>
              <option value="es">Español</option>
              <option value="de">Deutsch</option>
            </select>
          </div>
        </div>
      </div>
    </footer>
  );
};

// Main Landing Page
const LandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <HeroSection />
        <FeaturesSection />
        <HowItWorksSection />
        <SecurityFeatures />
        <TestimonialsSection />
        <IntegrationPartners />
        <PricingPreview />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
       <ScrollToTop />
    </div>
  );
};

export default LandingPage;
